import { render } from "./ModulesScreen.vue?vue&type=template&id=503c5d77&scoped=true"
import script from "./ModulesScreen.vue?vue&type=script&lang=js"
export * from "./ModulesScreen.vue?vue&type=script&lang=js"

import "./ModulesScreen.vue?vue&type=style&index=0&id=503c5d77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503c5d77"]])

export default __exports__